import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {DeviceStatusAdminComponent} from "./devicestatus-admin.component";
import {DeviceSummaryComponent} from "./device-summary.component";
import {DeviceSlotSummaryComponent} from "./deviceslot-summary.component";
import {DeployableGroupComponent} from "./deployable-group.component";
import {WebmateBrowserModule} from "../browser/webmate-browser.module";
import {RadioButtonModule} from 'primeng/radiobutton';
import {InputTextModule} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import {SelectModule} from 'primeng/select';
import {ResourceViewsModule} from '@webmate-web-core/shared/components/resources/resource-views.module';
import {AppInstallationComponent} from '@webmate-web-core/shared/components/device/appinstallation/app-installation.component';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {DeviceLogoComponent} from "@webmate-web-core/shared/components/device/device-logo.component";
import {TooltipModule} from "primeng/tooltip";
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {ProgressBarModule} from 'primeng/progressbar';
import {CheckboxModule} from 'primeng/checkbox';
import {PopoverModule} from 'primeng/popover';
import {ToggleSwitchModule} from 'primeng/toggleswitch';
import {FormsModule} from '@angular/forms';
import {ConsoleFactory} from '../../tools/console-factory/console-factory.service';
import {WmDirectivesModule} from '@webmate-web-core/shared/directives/directives.module';
import {DeployableSelectorComponent} from "@webmate-web-core/shared/components/device/deployable-selector.component";
import {AppListComponent} from '@webmate-web-core/shared/components/apps/app-list.component';
import {WmCalendarFormatPipe} from '@webmate-web-core/shared/utils/pipes/wm-calendar-format';
import {DataTestingIdPipe} from '@webmate-web-core/shared/utils/pipes/data-testing-id.pipe';
import {SplitButton} from 'primeng/splitbutton';
import {CopyableTextComponent} from '@webmate-web-core/shared/components/common/copyable-text.component';
import {FormsCommonsModule} from '@webmate-web-core/shared/components/forms-commons/forms-commons.module';
import {FullCalendarModule} from '@fullcalendar/angular';
import {SlotReservationEditorComponent} from './slot-reservation-editor.component';
import {DatePickerModule} from 'primeng/datepicker';
import {DeviceDetailsComponent} from './device-details.component';
import {DeviceSlotDetailsComponent} from './device-slot-details.component';

@NgModule({
    declarations: [
        DeviceLogoComponent,
        DeviceStatusAdminComponent,
        DeviceSummaryComponent,
        DeviceSlotSummaryComponent,
        SlotReservationEditorComponent,
        DeviceDetailsComponent,
        DeviceSlotDetailsComponent,
        DeployableGroupComponent,
        DeployableSelectorComponent,
        AppInstallationComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        WebmateBrowserModule,
        RadioButtonModule,
        InputTextModule,
        ButtonModule,
        SelectModule,
        ResourceViewsModule,
        FontAwesomeModule,
        TooltipModule,
        ProgressSpinnerModule,
        ProgressBarModule,
        CheckboxModule,
        PopoverModule,
        ToggleSwitchModule,
        WmDirectivesModule,
        AppListComponent,
        WmCalendarFormatPipe,
        DataTestingIdPipe,
        SplitButton,
        CopyableTextComponent,
        FormsCommonsModule,
        FullCalendarModule,
        DatePickerModule
    ],
    exports: [
        DeviceLogoComponent,
        DeviceStatusAdminComponent,
        DeviceSummaryComponent,
        DeviceSlotSummaryComponent,
        DeployableGroupComponent,
        DeployableSelectorComponent,
    ],
    providers: [
        ConsoleFactory
    ]
})
export class DeviceSharedModule { }
